export default {
  backendBaseUrl: process.env.REACT_APP_BACKEND_BASE_URL,
  awsRegion: process.env.AWS_REGION,
  awsPoolId: process.env.AWS_COGNITO_USER_POOL_ID,
  awsClientId: process.env.AWS_WEB_CLIENT_ID,
};
